<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">核算明细</li>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        size="large"
        v-if="$judge_auth('395')"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <div style="flex: 2; display: flex; flex-wrap: wrap; gap: 10px">
        <el-radio-group v-model="state.params.declare_status" @change="onLoad">
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :value="0">未申报</el-radio-button>
          <el-radio-button :value="1">已申报</el-radio-button>
        </el-radio-group>
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="工资表名称、单号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-date-picker
          v-model="state.params.tax_month"
          type="month"
          placeholder="税款所属月份"
          value-format="YYYY-MM"
          format="YYYY年M月"
          style="width: 140px"
        />
        <el-select
          v-model="state.params.customer_id"
          placeholder="所属客户"
          style="width: 240px"
        >
          <el-option
            v-for="item in state.customerData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadCustomer()">刷新</el-button>
          </template>
        </el-select>
        <div
          class="c-withholdingagent-search-box"
          @click="state.showWithholdingAgent = true"
        >
          <li style="flex: 1; display: flex; column-gap: 5px">
            <template v-if="state.withholding_agent_arr?.length > 0">
              <div
                class="c-withholdingagent-search-tag"
                style="
                  max-width: 200px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ state.withholding_agent_arr[0]?.name }}
              </div>
              <el-popover
                v-if="state.withholding_agent_arr?.length > 1"
                placement="right"
                width="auto"
                popper-style="max-height: 90vh;overflow-y: auto;"
              >
                <template #reference>
                  <div class="c-withholdingagent-search-tag" @click.stop="">
                    {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                  </div>
                </template>
                <template #default>
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      row-gap: 5px;
                      width: fit-content;
                    "
                  >
                    <ul
                      v-for="(item, index) in state.withholding_agent_arr"
                      :key="item"
                      style="
                        white-space: nowrap;
                        background-color: #f0f2f5;
                        color: var(--el-color-info);
                        border-radius: 4px;
                        font-size: 12px;
                        padding: 0 9px;
                        height: 24px;
                        line-height: 24px;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                      "
                    >
                      <li>{{ item.name }}</li>
                      <el-icon
                        @click.stop="
                          state.withholding_agent_arr.splice(index, 1)
                        "
                        color="#a2a2a2"
                        style="cursor: pointer"
                        ><CircleClose
                      /></el-icon>
                    </ul>
                  </div>
                </template>
              </el-popover>
            </template>
            <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
          </li>
          <el-icon
            v-if="state.withholding_agent_arr?.length > 0"
            @click.stop="delete state.withholding_agent_arr"
            color="#a2a2a2"
            ><CircleClose
          /></el-icon>
        </div>
        <el-select
          v-model="state.params.tax_bureau_id"
          placeholder="税局"
          style="width: 260px"
        >
          <el-option
            v-for="item in state.taxbureau_data"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadTaxBureau()">
              刷新
            </el-button>
          </template>
        </el-select>
        <el-select
          v-model="state.params.declare_type"
          placeholder="申报类型"
          style="width: 120px"
        >
          <el-option
            v-for="item in $constant.taxdeclare_declare_type"
            :key="item.Key"
            :label="item.Text"
            :value="item.Key"
          />
        </el-select>
        <el-select
          v-model="state.params.declare_kind"
          placeholder="申报种类"
          style="width: 120px"
        >
          <el-option label="正常申报" value="正常申报" />
          <el-option label="更正申报" value="更正申报" />
        </el-select>
        <el-config-provider
          :value-on-clear="null"
          :empty-values="[undefined, null]"
        >
          <el-select
            v-model="state.params.lock_status"
            placeholder="锁定状态"
            style="width: 120px"
          >
            <el-option label="未锁定" :value="0" />
            <el-option label="已锁定" :value="1" />
          </el-select>
        </el-config-provider>
        <el-input
          v-model="state.params.keywords_employee"
          style="width: 200px"
          placeholder="姓名、手机号、证件号"
          clearable
          @clear="
            delete state.params.keywords_employee;
            onLoad();
          "
          @paste.enter="
            $onKeywordsPaste($event, state.params, 'keywords_employee')
          "
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          column-gap: 10px;
          padding: 0 30px;
        "
      >
        <li style="text-align: center; min-width: 80px">
          <div style="color: #1e90ff; font-size: 18px">
            {{ state.statistics?._total }}
          </div>
          <text style="font-size: 80%; color: #a2a2a2">计薪人数</text>
        </li>
        <li style="text-align: center; min-width: 120px">
          <c_statistics
            :value="state.statistics?.income_amount"
            :key="state.statistics?.income_amount"
            color="#080"
          />
          <text style="font-size: 80%; color: #a2a2a2">本期收入总额</text>
        </li>
        <li style="text-align: center; min-width: 120px">
          <c_statistics
            :value="state.statistics?.net_salary"
            :key="state.statistics?.net_salary"
            color="#f00"
            bold
          />
          <text style="font-size: 80%; color: #a2a2a2">实发工资总额</text>
        </li>
        <li style="text-align: center; min-width: 120px">
          <c_statistics
            :value="state.statistics?.tax_refund_amount"
            :key="state.statistics?.tax_refund_amount"
            color="#ffa500"
          />
          <text style="font-size: 80%; color: #a2a2a2">个税金额</text>
        </li>
      </div>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        size="large"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="name"
          sortable="name"
          label="姓名"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          width="120"
          fixed="left"
        />
        <el-table-column prop="phone" label="手机号" width="140">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="手机号"
              @click="$onCopy(row.phone)"
            >
              {{ row.phone }}
            </text>
          </template>
        </el-table-column>
        <el-table-column prop="idcard" label="证件号" width="180">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.idcard)"
            >
              {{ row.idcard }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="工资表"
          :formatter="
            (row) =>
              $tab_GroupFormat(row.payroll_name, row.payroll_order_id || '')
          "
          :min-width="200"
        />
        <el-table-column
          prop="tax_month"
          label="税款所属期"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="idtype"
          label="证件类型"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.withholding_agent_name,
                row.unified_social_credit_identifier || '',
              )
          "
          :min-width="240"
        />
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          prop="customer_name"
          label="所属客户"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          prop="income_amount"
          sortable="income_amount"
          label="本期收入总额"
          :formatter="$tab_PriceFormat"
          align="right"
          width="160"
        />
        <el-table-column
          prop="payable_tax_amount"
          sortable="payable_tax_amount"
          label="累计应扣缴纳"
          :formatter="$tab_PriceFormat"
          align="right"
          width="160"
        />
        <el-table-column
          prop="paied_tax_amount"
          sortable="paied_tax_amount"
          label="累计已扣缴额"
          :formatter="$tab_PriceFormat"
          align="right"
          width="160"
        />
        <el-table-column
          prop="tax_refund_amount"
          sortable="tax_refund_amount"
          label="本期应补(退)税额"
          :formatter="$tab_PriceFormat"
          align="right"
          width="160"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { data_taxbureau_select, data_customer_select } from "@/http/data";
import {
  taxdeclareemployee_list,
  taxdeclareemployee_export,
} from "@/http/taxdeclareemployee";
import { dayjs, ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");

      onLoadTaxBureau();
      onLoadCustomer();
      onLoad();
    });

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      taxdeclareemployee_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list, statistics } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
          state.statistics = statistics;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      taxdeclareemployee_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onLoadTaxBureau,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onExport,
    };
  },
};
</script>
